import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface Props {
  companyId?: string;
}

export const useTotalUsers = ({ companyId }: Props) => {
  return useQuery({
    queryKey: ['crm/messages/users', companyId],
    queryFn: async () => {
      const response: iResponse<TotalUser> = await fetchAPI({
        method: 'GET',
        route: 'crm/messages/users',
        queryString: companyId ? `companyId=${companyId}` : ''
      });
      return response;
    }
  });
};

export default useTotalUsers;
